(function () {
  window.dukaanwalaContinuationLoaded = true;
  var STORAGE_KEY = "dukaanwala_continuation_token";
  var PARAM_NAME = "dw_continue";
  var ENDPOINT = "https://bfwhdpspseyuafquxshn.supabase.co/functions/v1/customer-order-message";
  var CURRENT_SCRIPT = document.currentScript;
  var SCRIPT_FLAG = CURRENT_SCRIPT ? CURRENT_SCRIPT.getAttribute("data-enabled") : null;
  var THEME_FLAG_ENABLED = window.THEME_CART_CONTINUATION_ENABLED === true
    || SCRIPT_FLAG === "true"
    || SCRIPT_FLAG === null;

  if (!THEME_FLAG_ENABLED) {
    return;
  }

  window.dukaanwalaDisableAutoCartOpen = true;

  function getTokenFromUrl() {
    try {
      return new URL(window.location.href).searchParams.get(PARAM_NAME) || "";
    } catch (error) {
      console.error("Dukaanwala continuation URL parse failed", error);
      return "";
    }
  }

  function rememberToken(token) {
    if (!token) return;
    window.sessionStorage.setItem(STORAGE_KEY, token);
  }

  function activeToken() {
    var urlToken = getTokenFromUrl();
    if (urlToken) {
      rememberToken(urlToken);
      return urlToken;
    }

    return window.sessionStorage.getItem(STORAGE_KEY) || "";
  }

  function forgetToken() {
    window.sessionStorage.removeItem(STORAGE_KEY);
    window.sessionStorage.removeItem(STORAGE_KEY + ":applied");
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete(PARAM_NAME);
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (error) {
      console.error("Dukaanwala continuation URL cleanup failed", error);
    }
  }

  function cartFetch(path, options) {
    return fetch(path, Object.assign({
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      }
    }, options || {}));
  }

  function safeQuantity(value) {
    var quantity = Number(value || 1);
    return Number.isFinite(quantity) && quantity > 0 ? Math.floor(quantity) : 1;
  }

  function toCartItems(items) {
    if (!Array.isArray(items)) return [];

    return items
      .filter(function (item) {
        return item && item.variant_id;
      })
      .map(function (item) {
        return {
          id: Number(item.variant_id),
          quantity: safeQuantity(item.quantity)
        };
      })
      .filter(function (item) {
        return Number.isFinite(item.id) && item.id > 0;
      });
  }

  function updateCartCounts(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function refreshCartCounts() {
    return fetch("/cart.js", { credentials: "same-origin", headers: { "Accept": "application/json" } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartCounts(cart.item_count || 0);
        document.body.classList.remove("cart-sidebar-show");
        return cart;
      });
  }

  function showStatus(message, kind) {
    var existing = document.getElementById("dukaanwala-continuation-status");
    if (existing) existing.remove();

    var status = document.createElement("div");
    status.id = "dukaanwala-continuation-status";
    status.setAttribute("role", kind === "error" ? "alert" : "status");
    status.style.cssText = [
      "position:fixed",
      "z-index:2147483000",
      "top:16px",
      "left:50%",
      "transform:translateX(-50%)",
      "width:min(92vw,680px)",
      "padding:16px 20px",
      "border-radius:10px",
      "box-shadow:0 12px 36px rgba(0,0,0,.25)",
      "font:600 15px/1.45 Arial,sans-serif",
      "color:#fff",
      "background:" + (kind === "error" ? "#b42318" : kind === "success" ? "#16794a" : "#1f2937")
    ].join(";");
    status.textContent = message;

    if (kind === "success") {
      var cartLink = document.createElement("a");
      cartLink.href = "/cart";
      cartLink.textContent = " Open cart";
      cartLink.style.cssText = "color:#fff;text-decoration:underline;margin-left:8px;";
      status.appendChild(cartLink);
    }

    document.body.appendChild(status);
    if (kind !== "error") {
      window.setTimeout(function () {
        if (status.parentNode) status.remove();
      }, kind === "success" ? 10000 : 4000);
    }
  }

  function reportDiagnostic(token, stage, message, metadata) {
    return fetch(ENDPOINT, {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        action: "continuation_diagnostic",
        token: token,
        stage: stage,
        message: String(message || "").slice(0, 300),
        metadata: metadata || {}
      })
    }).catch(function (error) {
      console.error("Dukaanwala continuation diagnostic failed", error);
    });
  }

  function markStage(error, stage) {
    var normalized = error instanceof Error ? error : new Error(String(error));
    if (!normalized.dukaanwalaStage) normalized.dukaanwalaStage = stage;
    return normalized;
  }

  function isCartUrl(url) {
    if (!url) return false;
    try {
      var parsed = new URL(url, window.location.origin);
      return parsed.origin === window.location.origin && parsed.pathname.replace(/\/+$/, "") === "/cart";
    } catch (error) {
      return String(url).replace(/\/+$/, "") === "/cart";
    }
  }

  function installCartRedirectGuard() {
    if (!window.halo || typeof window.halo.redirectTo !== "function" || window.halo.redirectTo.dukaanwalaGuarded) {
      return;
    }

    var originalRedirectTo = window.halo.redirectTo;
    window.halo.redirectTo = function (url) {
      if (window.dukaanwalaDisableAutoCartOpen && isCartUrl(url)) {
        refreshCartCounts().catch(function (error) {
          console.error("Dukaanwala cart count refresh failed", error);
        });
        return;
      }

      return originalRedirectTo.apply(this, arguments);
    };
    window.halo.redirectTo.dukaanwalaGuarded = true;
  }

  function installCartAddInterceptor() {
    document.addEventListener("submit", function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

      event.preventDefault();
      event.stopPropagation();

      fetch("/cart/add.js", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Accept": "application/json" },
        body: new FormData(form)
      })
        .then(function (response) {
          if (!response.ok) throw new Error("Cart add failed.");
          return refreshCartCounts();
        })
        .then(function () {
          if (typeof window.dukaanwalaRefreshCartState === "function") {
            return window.dukaanwalaRefreshCartState();
          }
        })
        .catch(function (error) {
          console.error("Dukaanwala add-to-cart failed", error);
        });
    }, true);
  }

  function fetchContinuation(token) {
    return fetch(ENDPOINT + "?token=" + encodeURIComponent(token), {
      method: "GET",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      return response.json().then(function (payload) {
        if (!response.ok || !payload || payload.ok !== true) {
          var error = new Error((payload && payload.error) || "Continuation link is not available.");
          error.dukaanwalaLookup = true;
          error.dukaanwalaCode = payload && payload.errorCode ? payload.errorCode : "lookup_failed";
          throw error;
        }
        return payload;
      });
    });
  }

  function updateCartAttributes(token) {
    return cartFetch("/cart/update.js", {
      method: "POST",
      body: JSON.stringify({
        note: "dw_continue=" + token,
        attributes: {
          dukaanwala_continuation_token: token,
          dw_continue: token
        }
      })
    }).then(function (response) {
      if (!response.ok) throw new Error("The continuation details could not be attached to the cart.");
      return response;
    });
  }

  function fetchCart() {
    return fetch("/cart.js", {
      credentials: "same-origin",
      headers: { "Accept": "application/json" }
    }).then(function (response) {
      if (!response.ok) throw new Error("The current cart could not be read.");
      return response.json();
    });
  }

  function validateItems(items) {
    if (!items.length) {
      return Promise.reject(new Error("None of the original order items are currently available."));
    }

    return Promise.all(items.map(function (item) {
      return fetch("/variants/" + encodeURIComponent(item.id) + ".js", {
        credentials: "same-origin",
        headers: { "Accept": "application/json" }
      }).then(function (response) {
        if (!response.ok) throw new Error("Item variant " + item.id + " no longer exists.");
        return response.json();
      }).then(function (variant) {
        if (!variant || Number(variant.id) !== item.id) {
          throw new Error("Item variant " + item.id + " could not be verified.");
        }
        if (variant.available !== true) {
          throw new Error((variant.name || "An item") + " is no longer in stock.");
        }
        return item;
      });
    }));
  }

  function cartItemsForRestore(cart) {
    if (!cart || !Array.isArray(cart.items)) return [];
    return cart.items.map(function (item) {
      var restored = {
        id: Number(item.variant_id || item.id),
        quantity: safeQuantity(item.quantity)
      };
      if (item.properties && Object.keys(item.properties).length) restored.properties = item.properties;
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        restored.selling_plan = item.selling_plan_allocation.selling_plan.id;
      }
      return restored;
    }).filter(function (item) {
      return Number.isFinite(item.id) && item.id > 0;
    });
  }

  function replaceCart(items) {
    return cartFetch("/cart/clear.js", { method: "POST" }).then(function (response) {
      if (!response.ok) throw new Error("The existing cart could not be prepared.");
      return cartFetch("/cart/add.js", {
        method: "POST",
        body: JSON.stringify({ items: items })
      });
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          throw new Error(payload.description || "The available items could not be added.");
        });
      }
      return response;
    });
  }

  function verifyCart(cart, items) {
    var quantities = {};
    (cart.items || []).forEach(function (item) {
      var id = Number(item.variant_id || item.id);
      quantities[id] = (quantities[id] || 0) + safeQuantity(item.quantity);
    });

    var mismatch = items.find(function (item) {
      return (quantities[item.id] || 0) < item.quantity;
    });
    if (mismatch) {
      throw markStage(
        new Error("The restored cart did not contain every expected item."),
        "cart_verify"
      );
    }
    return cart;
  }

  function applyContinuation(token, continuation) {
    var items = toCartItems(continuation.availableItems);
    var previousCart;

    return validateItems(items)
      .catch(function (error) {
        throw markStage(error, "variant_validation");
      })
      .then(function () {
        return fetchCart();
      })
      .then(function (cart) {
        previousCart = cart;
        return replaceCart(items).catch(function (error) {
          throw markStage(error, "cart_replace");
        });
      })
      .then(function () {
        return updateCartAttributes(token).catch(function (error) {
          throw markStage(error, "cart_verify");
        });
      })
      .then(function () {
        return fetchCart().catch(function (error) {
          throw markStage(error, "cart_verify");
        });
      })
      .then(function (cart) {
        verifyCart(cart, items);
        updateCartCounts(cart.item_count || 0);
        document.body.classList.remove("cart-sidebar-show");
        if (typeof window.dukaanwalaRefreshCartState === "function") {
          window.dukaanwalaRefreshCartState();
        }
        return cart;
      })
      .catch(function (error) {
        if (!previousCart) throw error;
        var restoreItems = cartItemsForRestore(previousCart);
        return cartFetch("/cart/clear.js", { method: "POST" })
          .then(function () {
            if (!restoreItems.length) return null;
            return cartFetch("/cart/add.js", {
              method: "POST",
              body: JSON.stringify({ items: restoreItems })
            });
          })
          .then(function () {
            throw error;
          }, function (restoreError) {
            reportDiagnostic(
              token,
              "cart_restore",
              restoreError && restoreError.message ? restoreError.message : "The previous cart could not be restored."
            );
            throw markStage(error, "cart_restore");
          });
      });
  }

  function init() {
    installCartRedirectGuard();
    installCartAddInterceptor();

    var token = activeToken();
    if (!token || window.sessionStorage.getItem(STORAGE_KEY + ":applied") === token) {
      return;
    }

    showStatus("Restoring the available items from your earlier order…", "loading");
    fetchContinuation(token)
      .then(function (continuation) {
        return applyContinuation(token, continuation);
      })
      .then(function () {
        window.sessionStorage.setItem(STORAGE_KEY + ":applied", token);
        showStatus("Your available items were added to the cart. You can continue shopping or check out.", "success");
        reportDiagnostic(token, "applied", "Continuation cart restored successfully.");
      })
      .catch(function (error) {
        console.error("Dukaanwala continuation failed", error);
        showStatus(error.message || "We could not restore this order. Your previous cart was kept.", "error");
        if (["invalid_token", "expired", "already_claimed", "missing_variant_reference", "not_claimable"].includes(error.dukaanwalaCode)) {
          forgetToken();
        }
        if (!error.dukaanwalaLookup) {
          reportDiagnostic(
            token,
            error.dukaanwalaStage || "cart_replace",
            error.message || "Continuation failed."
          );
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  window.setTimeout(installCartRedirectGuard, 500);
  window.setTimeout(installCartRedirectGuard, 1500);
})();
